import { Button, Dialog, DialogActions, DialogContent, Divider, Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';

const useStyle = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '15px',
    borderRadius: '6px',
    width: (props) => props.width,
    height: (props) => props.height,
  },
  actions: {
    borderTop: '1px solid #E4E7EC',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: (props) => props.width,
  },
  btn: {
    height: '40px',
    minWidth: '140px',
    borderRadius: '6px',
  },
  title: {
    fontFamily: 'Lato',
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '19.32px',
    color: '#10182B',
  },
  subTitle: {
    fontFamily: 'Lato',
    fontSize: '10px',
    fontWeight: 500,
    lineHeight: '13.8px',
    color: '#667085',
  },
});

export default function ConfirmationDialog({
  title,
  subText,
  onClose,
  isOpen,
  confirmFn,
  disagreeText = 'No',
  agreeText = 'Yes',
  width = '400px',
  height = '120px',
  Icon,
  disableBackdropClick = false,
}) {
  const classes = useStyle({ width, height });

  const handleClose = (event, reason) => {
    if (disableBackdropClick && reason === 'backdropClick') return;
    onClose(false);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent style={{ marginTop: '-20px' }}>
        <Grid container direction="column" justifyContent="center" className={classes.container} spacing={2}>
          <Grid item>{Icon && <Icon />}</Grid>
          {title && (
            <Grid item>
              <Typography id="alert-dialog-title" className={classes.title}>
                {title}
              </Typography>
            </Grid>
          )}
          {subText && (
            <Grid item>
              <Grid item>
                <Typography id="alert-dialog-title" className={classes.subTitle}>
                  {subText}
                </Typography>
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid item>
          <Divider />
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container direction="row" justifyContent="center" spacing={2}>
          <Grid item>
            <Button onClick={() => onClose(false)} variant="outlined" className={classes.btn}>
              {disagreeText}
            </Button>
          </Grid>
          <Grid item>
            <Button onClick={confirmFn} autoFocus variant="contained" color="primary" className={classes.btn}>
              {agreeText}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
